import { renderToolBlockInstance } from "../../shared/SimulatorWrapper/SimulatorWrapper";
import { forms } from "./Form/Form";
import Results from "./Results/Results";
import CustomErrorExpenses from "./Form/CustomErrorExpenses";

const TOOL_KEY = "effort_rate";

renderToolBlockInstance({
  toolKey: TOOL_KEY,
  formConfig: forms[TOOL_KEY],
  Results,

  BeforeSubmit: [CustomErrorExpenses]
});
